import { render, staticRenderFns } from "./SociosEmpresa.vue?vue&type=template&id=5ae4a295"
import script from "./SociosEmpresa.vue?vue&type=script&lang=js"
export * from "./SociosEmpresa.vue?vue&type=script&lang=js"
import style0 from "./SociosEmpresa.vue?vue&type=style&index=0&id=5ae4a295&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports